export default __webpack_public_path__ + "static/media/ai-trading-helper.acc130c9.png";